import { adminHttpClient } from '../../commons/adminHttpClient'
import PagedList from '../../commons/PagedList'
import EmailStatus from '../../../domain/mailHistory/emailStatus'

export type SearchUserActionHistoryItemResponse = {
  id: string
  companyId: string
  userId: string
  url: string
  method: string
  params?: string
  createdAt: string
  impersonatedBy?: string
  impersonatedByUserName?: string
}

export type SearchUserActionHistoryFilter = {
  pageNumber: number
  pageSize: number
  orderColumn: string
  orderDescending: boolean
  status?: EmailStatus
  q?: string
}

export const searchUserActionHistory = (filter: SearchUserActionHistoryFilter): Promise<PagedList<SearchUserActionHistoryItemResponse>> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 25,
    orderColumn: 'createdAt',
    orderDescending: false,
  }

  return adminHttpClient.get('/csi/UserActionLogHistory/Search', filter)
}
